import { render, staticRenderFns } from "./GuidanceModal.vue?vue&type=template&id=8f43b48c&"
import script from "./GuidanceModal.vue?vue&type=script&lang=js&"
export * from "./GuidanceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports